module.exports = __webpack_public_path__ + "img/model3.4d3fde80.png";